import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RouterApp from "./App";
import reportWebVitals from "./reportWebVitals";
import { configureAmplify } from "./const/amplify.js";

configureAmplify();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <RouterApp />
  </React.StrictMode>,
);

reportWebVitals();